/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../core/components';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LogService } from '../../../../../core/services';
import { Observable } from 'rxjs';
import { OrganisationsApiService } from '../../http';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-add-users',
    templateUrl: './add-users.component.html',
    styleUrls: ['./add-users.component.scss'],
})

export class AddUsersComponent extends BaseComponent {
    /**
     * Emit complete to parent component
     */
    @Output() public eventEmitter: EventEmitter<any> = new EventEmitter();

    /**
     * New IP FormGroup
     */
    public userForm: FormGroup;

    constructor(
        private cdr: ChangeDetectorRef,
        private formBuilder: FormBuilder,
        private logService: LogService,
        private organisationApiService: OrganisationsApiService
    ) {
        super();

        this.setupForm();
    }

    /**
     * Get form formPaths
     */
    get formEmails(): FormArray {
        return this.userForm.get('email') as FormArray;
    }

    /**
     * Submit organisation details
     */
    public submitUsers(): Observable<any> {
        return new Observable((observer) => {
            const data = this.userForm.value;
            this.organisationApiService.create(data)
                .pipe(takeUntil(this.destroyed$))
                .subscribe(() => {
                        this.eventEmitter.next(true);
                    },
                    error => {
                        this.logService.error('AddOrganisationComponent: submitOrganisation', 'Error submitting data', error);
                    },
                    () => {
                        observer.next();
                        observer.complete();
                    });
        });
    }

    /**
     * Set up the new load balancer form.
     * @private
     */
    private setupForm(): void {
        this.userForm = this.formBuilder.group({
            email: new FormArray([
                new FormControl(null, [Validators.required, Validators.email])
            ]),
        });
    }

    /**
     * Add a path to the paths FormArray.
     */
    public addEmail(): void {
        if (this.userForm.valid) {
            this.formEmails.push(new FormControl(null, [Validators.required, Validators.email]));
        }
    }
}

